"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageType = void 0;
exports.StorageType = {
    S3: "s3",
    BOX: "box",
};
